import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bf-card bf-recent" }
const _hoisted_2 = { class: "bf-recent__head" }
const _hoisted_3 = {
  key: 0,
  class: "bf-pill bf-pill--ok"
}
const _hoisted_4 = {
  key: 1,
  class: "bf-pill bf-pill--err"
}
const _hoisted_5 = {
  key: 2,
  class: "bf-pill bf-pill--info"
}
const _hoisted_6 = {
  key: 3,
  class: "bf-pill bf-pill--info"
}
const _hoisted_7 = {
  key: 4,
  class: "bf-pill bf-pill--mut"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "bf-recent__title" }, "Últimas Integrações"),
        _createElementVNode("div", { class: "bf-recent__subtitle" }, "Execuções mais recentes no período")
      ], -1)),
      _createVNode(_component_router_link, {
        class: "bf-recent__link",
        to: { name: 'ExecutionPage' }
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Ver histórico completo ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_v_data_table, {
      class: "bf-table",
      headers: _ctx.columns,
      items: _ctx.executions,
      loading: _ctx.isLoading,
      "items-per-page": _ctx.size,
      "hide-default-footer": ""
    }, {
      [`item.status`]: _withCtx(({ value }) => [
        (value == 'success' || value == 'Sucesso')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Sucesso "))
          : (value == 'error' || value == 'Erro')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Erro "))
            : (value == 'processing' || value == 'Processando')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Processando "))
              : (
            value == 'waiting-process' || value == 'Aguardando Processamento'
          )
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Aguardando Processamento "))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, " Não Executado "))
      ]),
      "no-data": _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode(" Não há execuções no período ", -1)
      ]))]),
      loading: _withCtx(() => [
        _createVNode(_component_v_skeleton_loader, { type: "table-row@5" })
      ]),
      _: 2
    }, 1032, ["headers", "items", "loading", "items-per-page"])
  ]))
}